import { token } from '@styled-system/tokens';

import type { ProductItemCondition } from '@/shared/api/types/generated';

export const getItemConditionLabel = (condition: ProductItemCondition): string => {
  const labels: Record<ProductItemCondition, string> = {
    veryGoodCondition: 'Très bon état',
    good: 'Bon',
    goodCondition: 'Bon état',
    satisfactory: 'Satisfaisant',
    newWithTag: 'Neuf avec étiquette',
    newWithoutTag: 'Neuf sans étiquette',
    somePiecesNotWorking: 'Certaines pièces ne fonctionnent pas',
    '%future added value': 'Inconnu',
  };

  return labels[condition] || 'Inconnu';
};

export const getItemConditionColor = (condition: ProductItemCondition): string => {
  const colors: Record<ProductItemCondition, string> = {
    veryGoodCondition: token.var('colors.accent.green'), // Vert
    good: token.var('colors.accent.green'), // Vert
    goodCondition: token.var('colors.accent.green'), // Vert
    satisfactory: token.var('colors.accent.orange'), // Orange
    newWithTag: token.var('colors.accent.green'), // Vert
    newWithoutTag: token.var('colors.accent.green'), // Vert
    somePiecesNotWorking: token.var('colors.accent.red'), // Rouge
    '%future added value': token.var('colors.font.muted'), // Gris
  };

  return colors[condition] || token.var('colors.font.muted');
};

export const getAvailableItemConditions = (): Array<{ value: ProductItemCondition; label: string }> => {
  const conditions: ProductItemCondition[] = [
    'veryGoodCondition',
    'good',
    'goodCondition',
    'satisfactory',
    'newWithTag',
    'newWithoutTag',
    'somePiecesNotWorking',
  ];

  return conditions.map((condition) => ({
    value: condition,
    label: getItemConditionLabel(condition),
  }));
};
